import { render } from "./AppCreateTeamLayout.vue?vue&type=template&id=e5265f46"
import script from "./AppCreateTeamLayout.vue?vue&type=script&lang=js"
export * from "./AppCreateTeamLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__